import script from "./GoodsList.vue?vue&type=script&setup=true&lang=js"
export * from "./GoodsList.vue?vue&type=script&setup=true&lang=js"

import "./GoodsList.vue?vue&type=style&index=0&id=20d774de&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-20d774de"]])

export default __exports__